import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'
import { useMlapProjectPagesStore } from '@/stores/mlapProjectPages'

// Client-side routed under the project layout: the payload seeds the page for
// the first render, later entries fetch the settings/lsa_attribution twin.
Styxie.Initializers.MlapProjectsSettingsLsaAttribution = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => {
    useMlapProjectStore(pinia).hydrate(props.project)
    useMlapProjectPagesStore(pinia).hydratePage('lsaAttribution', props)
  }
})
